import React from "react";

const TABS = [
  {
    background: "#F44A4A",
    iconClass: "icon-cctv-1",
  },
  {
    background: "#00C351",
    iconClass: "icon-cctv-2",
  },
  {
    background: "#A500F8",
    iconClass: "icon-cctv-3",
  },
  {
    background: "#C41162",
    iconClass: "icon-cctv-4",
  },
  {
    background: "#304FFE",
    iconClass: "icon-cctv-5",
  },
  {
    background: "#DA0307",
    iconClass: "icon-cctv-6",
  },
  {
    background: "#6200EA",
    iconClass: "icon-cctv-7",
  },
  {
    background: "#AA00FF",
    iconClass: "icon-cctv-8",
  },
  {
    background: "#00BFA5",
    iconClass: "icon-cctv-9",
  },
  {
    background: "#00BFA5",
    iconClass: "icon-cctv-9",
  },

  {
    background: "#00BFA5",
    iconClass: "icon-cctv-9",
  },

  {
    background: "#00BFA5",
    iconClass: "icon-cctv-9",
  },
];
const Item = ({ item, index }) => {
  const background = TABS[index % 9].background;
  let msg = item.plan_parent_text
    .replace(/amp;/g, "")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&#039;/g, "'")
    .replace(/&ldquo;/g, "\u201C")
    .replace(/&rdquo;/g, "\u201D");

  return (
    <>
      <div className=" grid grid-cols-12 gap-x-2 gap-y-1  bg-white rounded-lg py-2">
        <div className="col-span-3  sm:col-span-2 md:col-span-3 lg:col-span-2 flex items-start justify-center ">
          <i
            style={{ background }}
            className={`icon-programs text-white text-[30px] sm:text-[40px] md:text-[50px] lg:text-[60px] xl:text-[60px]  text-full p-2 rounded-full mt-1`}
          ></i>
        </div>
        <div className="col-span-9 md:col-span-9  xl:flex flex-column xl:justify-center ">
          <h2 className="font-bold">
            {" "}
            {item.plan_activity.replace(/<br>/g, "\n")}{" "}
          </h2>
          <h2 className=" text-sm">
            {typeof item.plan_parent_text === "string"
              ? msg.replace(/<br>/g, "\n")
              : ""}
          </h2>
        </div>
      </div>
    </>
  );
};

export default Item;
